import { useState } from 'react'

const useForm = valoresIniciais => {
  const [form, setForm] = useState(valoresIniciais)

  const onChange = campo => {
    return (evt) => {
      if (evt.target){
        if ( evt.target.type === 'checkbox') {
          if (evt.target.checked === true) {
            evt.target.value = 'S'
          }else if(evt.target.checked === false) {
            evt.target.value = 'N'
          }
        }
      }
      setForm({
        ...form,
        [campo]: evt.target.value
      })
    }
  }

  const onChangeDate = campo => {
    return (evt) => {
      if (evt.length != undefined) {
        console.log (evt.length)
        if (evt.length === 2) {
          setForm({
            ...form,
            [campo]: evt+'/'
          })
        } else if(evt.length === 5) {
          setForm({
            ...form,
            [campo]: evt+'/'
          })
        }else if (evt.length >= 6 && evt.length <= 10){
          setForm({
            ...form,
            [campo]: evt
          })
        }else if (evt.length > 10){
          setForm({
            ...form,
            [campo]: form[campo]
          })
        }
      } else {
        setForm({
          ...form,
          [campo]: evt.format('DD/MM/YYYY')
        })
      }
    }
  }

  const onChangeCustom = (campo, oposto) => {
    return (evt) => {
      let opostoValue = 'N',
          campoValue  = evt.target.value
      if (campoValue !== 'S') {
        opostoValue = 'S'
      }

      setForm({
        ...form,
        [campo]: campoValue,
        [oposto]: opostoValue
      })

    }
  }

  const onChangeSelect = campo => {
    return (dados) => {
      setForm({
        ...form,
        [campo]: dados
      })
    }
  }

  const onChangeArray = (campo, array) => {
    return (evt) => {
      if (evt.target){
        if ( evt.target.type === 'checkbox') {
          if (evt.target.checked === true) {
            evt.target.value = 'S'
          }else if(evt.target.checked === false) {
            evt.target.value = 'N'
          }
        }
      }
      const listform = {...form}
      listform[array][campo] = evt.target.value
      setForm(listform)
    }
  }

  return [form, onChange, setForm, onChangeSelect, onChangeDate, onChangeCustom, onChangeArray]
}
export default useForm
